import { Currency } from '@openeducation/pp-rn-shared-types';

export const toPrecision = (num: number, precision: number = 2): string =>
  (Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(
    precision
  );

export const toPrecisionCeil = (num: number, precision: number = 2): string =>
  (Math.ceil(num * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(
    precision
  );

const ZERO_DECIMAL_CURRENCIES = new Set<string>([Currency.CLP, Currency.PYG]);

const getCurrencyPrecision = (currency?: string): number =>
  currency && ZERO_DECIMAL_CURRENCIES.has(currency) ? 0 : 2;

export const toCurrencyPrecision = (num: number, currency?: string): string =>
  toPrecision(num, getCurrencyPrecision(currency));

export const toCurrencyPrecisionCeil = (
  num: number,
  currency?: string
): string => toPrecisionCeil(num, getCurrencyPrecision(currency));

export const addThousandSeparator = (num: number | string) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getDisplayPrice = (num: number, currency: string): string =>
  `${currency} ${addThousandSeparator(toCurrencyPrecision(num, currency))}`;

export const formatCardNumber = (
  cardNumber: string,
  isAmericanExpress?: boolean
): string => {
  const cleanedInput = cardNumber.replace(/\W/g, '');

  const formattedNumber = isAmericanExpress
    ? cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3')
    : cleanedInput.replace(/(\w{4})/g, '$1 ');

  return formattedNumber.replaceAll('X', '*').trim();
};
